import {
  PlanConsistencyStatus,
  PlanSubmissionStatus,
} from '@ebalance/proto/bfftypes/v1/plan_submission_pb'

import type { StatusBadgeInfo } from '~/models/planSubmission/statusBadge'
import { deriveStatusBadge } from '~/models/planSubmission/statusBadge'

/**
 * proto row に badge 情報を付与した汎用型。
 * R は ProcurementPlanRow / GenerationSalesPlanRow のような
 * { status: PlanSubmissionStatus } を持つ proto row 型。
 */
type BadgeSourceRow = {
  status: PlanSubmissionStatus
  consistencyStatus?: PlanConsistencyStatus
}

export type RowWithBadge<R extends BadgeSourceRow> = {
  row: R
  badge: StatusBadgeInfo
}

/**
 * 整合ステータスが「不整合解消済み」の「不整合」は、値・ラベルは「不整合」のまま、
 * バッジを目立たない色 (neutral) にして警告アイコンを出さない (plan-common.md
 * §一覧テーブルの「整合ステータス」列「解消済みにした不整合の提出ステータス」)。
 * ステータス絞り込みの受領済の条件 (`planListStatusFilter.ts`) とは別で、こちらは
 * 計画内不整合が残る計画を含まない。
 */
export function toRowsWithBadge<R extends BadgeSourceRow>(
  rows: R[],
): Array<RowWithBadge<R>> {
  return rows.map((row) => {
    const badge = deriveStatusBadge(row.status)
    const resolved =
      row.status === PlanSubmissionStatus.INCONSISTENT &&
      row.consistencyStatus === PlanConsistencyStatus.MISMATCH_RESOLVED
    return {
      row,
      badge: resolved ? { ...badge, hasWarning: false, muted: true } : badge,
    }
  })
}
